import React, { useState } from 'react';
import { Box, Paper, Tabs, Tab } from '@mui/material';
import { PageContainer } from 'components/shared';
import EnvironmentSettings from './environmentsettings';
import AppSettings from './appsettings';
import SoftwareUpdate from './softwareupdate';
import LanguageSettings from './languagesettings';
import CurrencySettings from './currencysettings';
import CookieSettings from './cookiesettings';
import CleanDatabase from './cleandatabase';

const NavigationBar = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <PageContainer
      title="System Setup"
      subtitle="Configure environment, application, currency, language and other system-wide preferences."
    >
      <Paper
        variant="outlined"
        sx={{ borderColor: 'divider', bgcolor: 'background.paper', overflow: 'hidden' }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.alt' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="System setup tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Environment Settings" />
            <Tab label="App Settings" />
            <Tab label="Software Update" />
            <Tab label="Language" />
            <Tab label="Currency" />
            <Tab label="Cookies" />
            <Tab label="Clean Database" />
          </Tabs>
        </Box>

        <Box sx={{ p: { xs: 2, md: 3 }, overflowY: 'auto', minHeight: '70vh' }}>
          {value === 0 && <EnvironmentSettings />}
          {value === 1 && <AppSettings />}
          {value === 2 && <SoftwareUpdate />}
          {value === 3 && <LanguageSettings />}
          {value === 4 && <CurrencySettings />}
          {value === 5 && <CookieSettings />}
          {value === 6 && <CleanDatabase />}
        </Box>
      </Paper>
    </PageContainer>
  );
};

export default NavigationBar;
